import { render } from "./Tiptap.vue?vue&type=template&id=2f1a8874"
import script from "./Tiptap.vue?vue&type=script&lang=js"
export * from "./Tiptap.vue?vue&type=script&lang=js"

import "./Tiptap.vue?vue&type=style&index=0&id=2f1a8874&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/defensie/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__